import { ItemList } from 'orm'

class AdminStartingValueList extends ItemList {
    getEntityKey() {
        return "admin/starting_value"
    }
}

export const adminStartingValueList = new AdminStartingValueList("admin_starting_value__default")
